<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['wave']" placeholder="business.label.wave" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['order.no']" placeholder="business.label.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['customer.no']" placeholder="business.label.customerNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['customer.name']" placeholder="business.label.customerName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-date-range-picker v-model="query.range" clearable linked-panels placeholder="business.label.invoiceTime" type="date" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading" @cell-click="({row})=>showDetails(row)">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="issue.issueTime" title="business.label.issueTime" width="170"/>
        <vxe-column field="order.no" title="business.label.orderNo" width="140"/>
        <vxe-column field="dispatch.wave" title="business.label.wave" width="150"/>
        <vxe-column field="owner.name" title="business.label.owner"/>
        <vxe-column field="customer.no" title="business.label.customerNo"/>
        <vxe-column field="customer.name" title="business.label.customerName"/>
        <vxe-column field="order.stagingArea" title="business.label.stagingArea"/>
        <vxe-column field="pickupMode.name" title="business.label.pickupMode"/>
        <vxe-column field="orderType.name" title="business.label.orderType"/>
        <vxe-column field="order.printTimes" title="business.label.printTimes"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.preview" icon="vxe-icon-print" status="warning" @click.stop="print(row,true)"/>
            <vxe-button content="button.print" icon="vxe-icon-print" status="primary" @click.stop="print(row,false)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :pageSizes="[5, 10, 15, 20]" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll, post } from '@/api/Api'
import api from '@/api'
import moment from 'moment'
import { DeviceHandler } from '@/deviceHelper'
import { getWarehouse } from '@/utils/util'

export default {
  name: 'DeliverPrintOrder',
  data() {
    return {
      warehouse: getWarehouse(),
      loading: false,
      data: [],
      query: {
        'wave': '',
        'order.no': '',
        'customer.no': '',
        'customer.name': '',
        orderStatusRange: { start: 'WORK_READY', end: 'TERMINATED' },
        printConfirm: false,
        virtual: false,
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      },
      page: 1,
      size: 5,
      contentSize: 0
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.range.length > 0) {
        args['issueDateRange'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['issueDateRange'] = null
      }
      findAll('dispatchOrderListFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
          if (this.data.length > 0) {
            this.$refs.table.setRadioRow(this.data[0])
            this.$refs.table.setCurrentRow(this.data[0])
            this.showDetails(this.data[0])
          } else {
            this.clearDetails()
          }
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query['wave'] = ''
      this.query['order.no'] = ''
      this.query['customer.no'] = ''
      this.query['customer.name'] = ''
      this.query['range'] = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      this.refresh()
    },
    print(row, preview) {
      this.loading = true
      const args = {
        'query.no': 'saleOrderTagPrint',
        'sql': null,
        args: { so: row.order.id }
      }
      post(api.adminQuery, {}, args).then(res => {
        if (res.success) {
          const data = res.result.map(item => {
            item.bz = item.bz ? item.bz : ''
            return item
          })
          if (data.length > 0) {
            const printList = [
              {
                'PLAN_CODE': '24648806',
                'WH_ID': this.warehouse.id,
                'DATA': data,
                PREVIEW: preview
              }
            ]
            DeviceHandler.printWithDataList(printList, (item, res) => {
              if (res.hasOwnProperty('msg')) {
              }
            })
          }
        }
      }).finally(() => this.loading = false)
    },
    differ() {

    },
    showDetails(row) {
      this.$emit('showDetails', row)
    },
    clearDetails() {
      this.$emit('clearDetails')
    }
  }
}
</script>